// ============================================================
// shared/src/dto/upstream.dto.ts
// JD callback 五类事件 zod schema（严格原字段名）
// ============================================================

import { z } from 'zod';

/** INSURE 事件 schema（京东原字段名 evenType/sign） */
export const insureSchema = z.object({
  appBizId: z.string().optional(),
  appKey: z.string().min(1),
  bxBizId: z.string().optional(),
  evenType: z.literal('INSURE'),
  give: z.enum(['0', '1']),
  productCode: z.string().min(1),
  productName: z.string().min(1),
  sign: z.enum(['0', '1']),
  beginTime: z.string().min(1),
  endTime: z.string().min(1),
  allPremium: z.string().optional(),
  allPeriod: z.string().optional(),
  premium: z.string().optional(),
  nextPayTime: z.string().optional(),
  openRenew: z.string().optional(),
  relaPolicyId: z.string().optional(),
});

/** ORDER_UNDER_FAIL 事件 schema */
export const orderUnderFailSchema = z.object({
  appBizId: z.string().optional(),
  appKey: z.string().min(1),
  bxBizId: z.string().optional(),
  evenType: z.literal('ORDER_UNDER_FAIL'),
  give: z.enum(['0', '1']),
  productCode: z.string().min(1),
  productName: z.string().min(1),
  sign: z.enum(['0', '1']),
  beginTime: z.string().min(1),
  endTime: z.string().min(1),
  openRenew: z.string().optional(),
  relaPolicyId: z.string().optional(),
});

/** SURRENDER 事件 schema */
export const surrenderSchema = z.object({
  appBizId: z.string().optional(),
  appKey: z.string().min(1),
  bxBizId: z.string().optional(),
  evenType: z.literal('SURRENDER'),
  surrenderTime: z.string().min(1),
  surrenderPrice: z.string().min(1),
});

/** RENEWAL 事件 schema */
export const renewalSchema = z.object({
  appBizId: z.string().optional(),
  appKey: z.string().min(1),
  bxBizId: z.string().optional(),
  evenType: z.literal('RENEWAL'),
  payTime: z.string().min(1),
  payPrice: z.string().min(1),
  nextPayTime: z.string().min(1),
  currentPeriod: z.string().min(1),
});

/** TERMINATE 事件 schema */
export const terminateSchema = z.object({
  appBizId: z.string().optional(),
  appKey: z.string().min(1),
  bxBizId: z.string().optional(),
  evenType: z.literal('TERMINATE'),
  signStatus: z.enum(['0', '1']),
  terminateTime: z.string().min(1),
});

/** 五类事件联合 schema（通过 evenType 判别） */
export const jdCallbackSchema = z.discriminatedUnion('evenType', [
  insureSchema,
  orderUnderFailSchema,
  surrenderSchema,
  renewalSchema,
  terminateSchema,
]);

/** JD callback 入站原始数据类型 */
export type JdCallbackRaw = z.infer<typeof jdCallbackSchema>;
